import { errorPlayerContainerNotCreated } from './errors';
import { tafMediaTrackRolesAsSdk } from './utils';
export const playerSetAudioTrack = (container, parameters) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getAny();
    const track = parameters.track;
    player.setAudioTrack({
        id: track.id,
        locale: track.locale,
        codec: track?.codec ?? undefined,
        roles: tafMediaTrackRolesAsSdk(track?.rolesWrapper),
    });
};
